import { FAIcon, Theme, TagStyle, Tag, SearchDataStructure, AttributeTypes } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { dateTimeToCustomFormat } from '../../../ui/utils';

export interface MasterData {
  campaign: {
    campaignEnd?: string;
    campaignId?: string;
    campaignName?: string;
    campaignStart: string;
    recId?: number;
    status?: string;
  }[];
  reward?: {
    recId: number;
    rewardCode: string;
    rewardName: string;
  }[];
}
export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Participant Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Participant ABO ID',
    key: 'loginId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Participation Type',
    key: 'isIndividualTeam',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'yes',
        value: 'INDIVIDUAL',
      },
      {
        key: 'no',
        value: 'TEAM',
      },
    ],
  },
  {
    name: 'Enrollment ID',
    key: 'recId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Order Qualified',
    key: 'orderStatus',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'yes',
        value: 'YES',
      },
      {
        key: 'no',
        value: 'NO',
      },
    ],
  },
  {
    name: 'Achieved Winning Criteria',
    key: 'isIndividualAchieved',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'yes',
        value: 'YES',
      },
      {
        key: 'no',
        value: 'NO',
      },
      {
        key: 'pending',
        value: 'PENDING',
      },
    ],
  },
  // {
  //   name: 'Status',
  //   key: 'status',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: true,
  //   dataset: [
  //     {
  //       key: 'active',
  //       value: 'ACTIVE',
  //     },
  //     {
  //       key: 'inactive',
  //       value: 'INACTIVE',
  //     },
  //   ],
  // },
];

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

export const getParticipantListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'recId',
    text: translation('admin.teams.recId'),
    width: 2,
    sortable: true,
    render: (object: IProductBO) => <span>{object.recId}</span>,
  },
  {
    key: 'name',
    text: translation('admin.teamEdit.participantName'),
    width: 4,
    sortable: true,
    render: (object: IProductBO) => <span>{object.name === null ? '-' : object.name}</span>,
  },
  {
    key: 'loginId',
    text: translation('admin.teamEdit.participantAboId'),
    width: 4,
    sortable: true,
    render: (object: IProductBO) => <span>{object.loginId === null ? '-' : object.loginId}</span>,
  },
  {
    key: 'teamId',
    text: translation('admin.teams.teamId'),
    width: 4,
    sortable: false,
    render: (object: IProductBO) => <span>{object.isIndividualTeam === 'INDIVIDUAL' ? 'IND' : object.teamId}</span>,
  },
  {
    key: 'weightInDate',
    text: translation('admin.teamEdit.weighIn'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => (
      <span>{object.weightInDate === null ? '-' : dateTimeToCustomFormat(object.weightInDate, 'DD/MM/yyyy')}</span>
    ),
  },
  {
    key: 'weightOutDate',
    text: translation('admin.teamEdit.weighOut'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => (
      <span>{object.weightOutDate === null ? '-' : dateTimeToCustomFormat(object.weightOutDate, 'DD/MM/yyyy')}</span>
    ),
  },
  // {
  //   key: 'acknowledgeDateTimeOut',
  //   text: translation('admin.teamEdit.acknowledgedDateOut'),
  //   sortable: true,
  //   width: 4,
  //   render: (object: IProductBO) => (
  //     <span>
  //       {object.weightOut.acknowledgeDateTime === null
  //         ? '-'
  //         : dateTimeToCustomFormat(object.weightOut.acknowledgeDateTime, 'DD/MM/yyyy')}
  //     </span>
  //   ),
  // },
  {
    key: 'orderStatus',
    text: translation('admin.teamEdit.purchase'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.orderStatus === 'YES' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.orderStatus}
        />
      </span>
    ),
  },
  {
    key: 'isIndividualAchieved',
    text: translation('admin.teamEdit.achieved'),
    sortable: false,
    width: 4,
    render: (object: IProductBO) => (
      <Tag
        theme={
          object.isIndividualAchieved === 'YES'
            ? Theme.SUCCESS
            : object.isIndividualAchieved === 'NO'
              ? Theme.WARNING
              : Theme.BLUE
        }
        style={TagStyle.OUTLINE}
        text={object.isIndividualAchieved}
      />
    ),
  },
  {
    key: 'status',
    text: translation('admin.teamEdit.status'),
    sortable: true,
    width: 2,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'actions',
    width: 1,
    text: translation('admin.teamEdit.actions'),
    render: (object: IProductBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
        />
      </>
    ),
  },
];
